import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Typography variant="h4" gutterBottom sx={{maxWidth: "80%", pb: 4}}>
        Product not found in our Database, Please try another product
      </Typography>
      <Button variant="contained" onClick={() => navigate("/products")}>
        Go Back
      </Button>
    </Box>
  );
};

export default Error;
